// Voice barks (rebuild.md §8.2, Appendix C): dry dub takes from the anime, normalised by `npm run media`
// into public/audio/barks/{lineId}.mp3. Subtitles are the film's own lines (tools/media/film-lines.json).
import type { CastId } from './types.ts';

export interface BarkDef {
  line: string;
  speaker: CastId;
  /** Subtitle (always shown with the bark). */
  text: string;
  /** Generated in the cast voice (§8.6) rather than taken from the film. */
  generated?: boolean;
}

export const BARKS: Readonly<Record<string, BarkDef>> = {
  "C5-13_00": { line: "C5-13_00", speaker: 'hilda', text: "Correct." },
  "C9-04_04": { line: "C9-04_04", speaker: 'hilda', text: "Correct." },
  "E-07_01": { line: "E-07_01", speaker: 'hilda', text: "Correct." },
  "C4-08_01": { line: "C4-08_01", speaker: 'echo', text: "Correct." },
  "C4-08_03": { line: "C4-08_03", speaker: 'echo', text: "Correct." },
  "C9-07_03": { line: "C9-07_03", speaker: 'echo', text: "Correct." },
  "C5-07_00": { line: "C5-07_00", speaker: 'hilda', text: "No." },
  "C8-02_02": { line: "C8-02_02", speaker: 'hilda', text: "No." },
  "C1-14_00": { line: "C1-14_00", speaker: 'echo', text: "Correction." },
  "C12-11_01": { line: "C12-11_01", speaker: 'echo', text: "Correction." },
  "C4-07_04": { line: "C4-07_04", speaker: 'echo', text: "Operator error rate rising." },
  "C4-07_03": { line: "C4-07_03", speaker: 'echo', text: "Also recommend coffee." },
  "P09_00": { line: "P09_00", speaker: 'bureau', text: "Notice of pending audit." },
  "C8-09_00": { line: "C8-09_00", speaker: 'bureau', text: "Inspection within seven days." },
  "C11-04_02": { line: "C11-04_02", speaker: 'hilda', text: "That's inconvenient." },
  "P07_01": { line: "P07_01", speaker: 'bureau', text: "Compliance status: acceptable." },
  "P05_01": { line: "P05_01", speaker: 'bureau', text: "Continuity is efficiency. Efficiency is survival. File your yield." },
  "P08_00": { line: "P08_00", speaker: 'bureau', text: "Atom economy: sixty-seven percent. Audit heat increased." },
  "C1-09_00": { line: "C1-09_00", speaker: 'hilda', text: "Third rule. Nothing unlabeled." },
  "C1-06_00": { line: "C1-06_00", speaker: 'hilda', text: "Pay me." },
  "C1-17_00": { line: "C1-17_00", speaker: 'echo', text: "Toaster classification unsupported." },
  "C2-03_00": { line: "C2-03_00", speaker: 'mei', text: "lab still standing?" },
  "C2-03_01": { line: "C2-03_01", speaker: 'operator', text: "Define standing." },
  "C2-06_01": { line: "C2-06_01", speaker: 'mei', text: "scarcity." },
  "C2-06_02": { line: "C2-06_02", speaker: 'operator', text: "Robbery." },
  "C2-07_00": { line: "C2-07_00", speaker: 'mei', text: "robbery has worse accounting." },
  "C2-07_01": { line: "C2-07_01", speaker: 'mei', text: "this has an invoice." },
  "C2-04_02": { line: "C2-04_02", speaker: 'mei', text: "luxury." },
  "C1-08_00": { line: "C1-08_00", speaker: 'hilda', text: "Atom economy is second." },
  "C4-02_00": { line: "C4-02_00", speaker: 'echo', text: "Yield: zero point eight one." },
  "C4-02_01": { line: "C4-02_01", speaker: 'echo', text: "Wash inefficient." },
  "C4-02_02": { line: "C4-02_02", speaker: 'echo', text: "Old bench used wet workup at four degrees Celsius." },
  "C4-07_00": { line: "C4-07_00", speaker: 'operator', text: "Show related fragments." },
  "C4-07_01": { line: "C4-07_01", speaker: 'echo', text: "Insufficient reconstruction." },
  "C5-07_02": { line: "C5-07_02", speaker: 'hilda', text: "Your shoulders did." },
  "C5-11_00": { line: "C5-11_00", speaker: 'hilda', text: "Hazard rate." },
  "C5-14_01": { line: "C5-14_01", speaker: 'hilda', text: "I disapprove professionally." },
  "C6-02_00": { line: "C6-02_00", speaker: 'hilda', text: "Bench A." },
  "C6-03_00": { line: "C6-03_00", speaker: 'hilda', text: "I recognise that expression." },
  "C6-06_00": { line: "C6-06_00", speaker: 'hilda', text: "Excellent." },
  "C6-07_01": { line: "C6-07_01", speaker: 'hilda', text: "That's because sarcasm remains untaxed." },
  "C7-04_00": { line: "C7-04_00", speaker: 'operator', text: "They copied the reaction geometry." },
  "C7-04_01": { line: "C7-04_01", speaker: 'hilda', text: "Can you prove it?" },
  "C7-04_03": { line: "C7-04_03", speaker: 'hilda', text: "Can you afford to prove it?" },
  "C7-06_00": { line: "C7-06_00", speaker: 'operator', text: "Apparently truth has a subscription fee." },
  "C8-01_00": { line: "C8-01_00", speaker: 'hilda', text: "Off-spec." },
  "C8-02_00": { line: "C8-02_00", speaker: 'hilda', text: "Correct manifest." },
  "C8-02_01": { line: "C8-02_01", speaker: 'operator', text: "Supplier error?" },
  "C8-03_00": { line: "C8-03_00", speaker: 'hilda', text: "Expensive sabotage." },
  "C8-04_01": { line: "C8-04_01", speaker: 'echo', text: "Likely deliberate substitution." },
  "C8-05_00": { line: "C8-05_00", speaker: 'kirov', text: "I hope your expansion is proceeding smoothly." },
  "C8-06_00": { line: "C8-06_00", speaker: 'operator', text: "He's either responsible... or has the best comedic timing in the Sprawl." },
  "C9-02_00": { line: "C9-02_00", speaker: 'echo', text: "Annotation recovered." },
  "C9-02_01": { line: "C9-02_01", speaker: 'echo', text: "Ligand geometry mismatch." },
  "C9-03_00": { line: "C9-03_00", speaker: 'mei', text: "tier-zero precursor." },
  "C9-05_00": { line: "C9-05_00", speaker: 'm', text: "You are one functional group away." },
  "C9-06_00": { line: "C9-06_00", speaker: 'kirov', text: "We remain open to licensing discussions." },
  "C9-07_01": { line: "C9-07_01", speaker: 'echo', text: "Deletion has no therapeutic classification." },
  "C10-02_00": { line: "C10-02_00", speaker: 'mei', text: "corporate weather event at three o'clock." },
  "C10-04_00": { line: "C10-04_00", speaker: 'kirov', text: "Your work remains excellent." },
  "C10-04_01": { line: "C10-04_01", speaker: 'operator', text: "There it is." },
  "C10-04_03": { line: "C10-04_03", speaker: 'operator', text: "The compliment before the invoice." },
  "C10-06_00": { line: "C10-06_00", speaker: 'mei', text: "for the record, i suddenly understand capitalism." },
  "C10-09_00": { line: "C10-09_00", speaker: 'operator', text: "Because you own the first sentence." },
  "C11-02_00": { line: "C11-02_00", speaker: 'echo', text: "Chelation profile stable." },
  "C11-02_01": { line: "C11-02_01", speaker: 'echo', text: "Purification sequence ready." },
  "C11-02_02": { line: "C11-02_02", speaker: 'echo', text: "Estimated final yield: zero point seven four." },
  "C11-04_00": { line: "C11-04_00", speaker: 'hilda', text: "How long?" },
  "C11-04_01": { line: "C11-04_01", speaker: 'echo', text: "Current protocol: three hours, eight minutes." },
  "C11-04_03": { line: "C11-04_03", speaker: 'operator', text: "Strong language." },
  "C12-09_00": { line: "C12-09_00", speaker: 'operator', text: "ECHO. Alternatives." },
  "C12-09_01": { line: "C12-09_01", speaker: 'echo', text: "One." },
  "C12-09_02": { line: "C12-09_02", speaker: 'echo', text: "Wet workup at four degrees Celsius." },
  "C12-20_00": { line: "C12-20_00", speaker: 'hilda', text: "That's it?" },
  "C9-05_02": { line: "C9-05_02", speaker: 'm', text: "Try not to become predictable." },
  "C9-04_00": { line: "C9-04_00", speaker: 'hilda', text: "I need eight clean filings before the audit." },
  "C10-05_00": { line: "C10-05_00", speaker: 'kirov', text: "Thirty percent ownership." },
  "C12-11_00": { line: "C12-11_00", speaker: 'operator', text: "That method never scaled." },
  "C12-20_02": { line: "C12-20_02", speaker: 'hilda', text: "Expected more lightning." },
  "C12-20_03": { line: "C12-20_03", speaker: 'operator', text: "Budget cuts." },
  "C13-02_00": { line: "C13-02_00", speaker: 'kirov', text: "Final offer remains available." },
  "C13-02_02": { line: "C13-02_02", speaker: 'm', text: "You know what exclusive means." },
  "C13-02_03": { line: "C13-02_03", speaker: 'm', text: "You also know what publication means." },
  "C13-02_04": { line: "C13-02_04", speaker: 'm', text: "Interesting that both use the word \"public\"." },
  "C13-02_05": { line: "C13-02_05", speaker: 'm', text: "Only one means it." },
  "C13-02_06": { line: "C13-02_06", speaker: 'mei', text: "before you ask, i recommend the option where you continue purchasing reagents from me." },
  "C13-02_07": { line: "C13-02_07", speaker: 'operator', text: "Insightful." },
  "C13-02_08": { line: "C13-02_08", speaker: 'mei', text: "i provide strategic consulting now." },
  "C13-02_10": { line: "C13-02_10", speaker: 'mei', text: "twelve percent." },
  "C14-02_00": { line: "C14-02_00", speaker: 'hilda', text: "You realise the royalty becomes zero." },
  "C14-02_01": { line: "C14-02_01", speaker: 'operator', text: "Yes." },
  "C14-02_02": { line: "C14-02_02", speaker: 'hilda', text: "Tier-1 becomes impossible." },
  "C14-06_00": { line: "C14-06_00", speaker: 'hilda', text: "Procedure says verify twice." },
  "C14-08_00": { line: "C14-08_00", speaker: 'operator', text: "Verified." },
  "C14-08_01": { line: "C14-08_01", speaker: 'hilda', text: "Then press it once." },
  "C15-02_00": { line: "C15-02_00", speaker: 'kirov', text: "Congratulations." },
  "C15-05_00": { line: "C15-05_00", speaker: 'hilda', text: "No complaint?" },
  "C15-05_01": { line: "C15-05_01", speaker: 'operator', text: "He congratulated me." },
  "C15-05_02": { line: "C15-05_02", speaker: 'hilda', text: "Ah." },
  "C15-05_04": { line: "C15-05_04", speaker: 'hilda', text: "Devastating." },
  "E-07_00": { line: "E-07_00", speaker: 'operator', text: "We're barely solvent." },
  "E-09b_02": { line: "E-09b_02", speaker: 'hilda', text: "Minus my fifteen percent." },
  "E-09_00": { line: "E-09_00", speaker: 'm', text: "Good." },
  "E-10_00": { line: "E-10_00", speaker: 'echo', text: "Yield: zero point eight eight." },
  "E-10_01": { line: "E-10_01", speaker: 'echo', text: "Atom economy acceptable." },
  "E-10_02": { line: "E-10_02", speaker: 'echo', text: "Rent projection marginal." },
  "E-11_00": { line: "E-11_00", speaker: 'echo', text: "Query. ECHO upgrade allocation?" },
  "E-12_00": { line: "E-12_00", speaker: 'hilda', text: "Zero." },
  "E-13_00": { line: "E-13_00", speaker: 'echo', text: "Reason?" },
  "E-14_00": { line: "E-14_00", speaker: 'hilda', text: "Toasters don't get upgrades." },
};

export const BARK_IDS: ReadonlySet<string> = new Set(Object.keys(BARKS));

export function bark(line: string): BarkDef | undefined {
  return BARKS[line];
}
